export const WIDGET_HIDDEN_ROUTES = [
  "/messages/new",
  "/messages",
  "/live",
  "/workflows/edit",
  "/workflows/new",
  "/workflows/view",
  "/discover",
  "/settings/branded_apps_builder_ui",
  "/settings/pages/edit",
] as const;
